<template>
    <div class="wrapper flex flex-direction">
        <header-menu-modular></header-menu-modular>
        <div class="flex flex-sub margin-top-sm">
            <transition name="slide-fade">
                <menu-modular v-if="menuVisible" :nav-index="navIndex"></menu-modular>
            </transition>
            <div :class="{max:!menuVisible}" class="main-container flex flex-direction">
                <page-title-modular :cancel="cancel" :title="title"></page-title-modular>
                <div class="content flex-sub flex flex-direction">
                    <router-view class="flex-sub" @setIndex="getIndex(arguments)"></router-view>
                </div>
            </div>
        </div>
        <footer-modular></footer-modular>
        <router-link to="/web/staff/version">
            <img class="version" src="../../assets/img/icon_version.png" alt="" :class="{active:version_active}" @mouseenter="version_active = true" @mouseout="versionOut"/>
        </router-link>
        <version-index-detail-dialog :detailDialogVisible="detailDialogVisible" :nid="cur_nid"
                                     @watchState="watchState"></version-index-detail-dialog>
    </div>
</template>

<script>

import MenuModular from "@/views/web/components/MenuModular";
import PageTitleModular from "@/views/web/components/PageTitleModular";
import HeaderMenuModular from "@/views/web/components/HeaderMenuModular";
import FooterModular from "@/views/web/components/FooterModular";
import VersionIndexDetailDialog from "@/views/web/components/VersionIndexDetailDialog";
import {getVersionDetail} from "@/api";

export default {
    name: "Home",
    components: {
        VersionIndexDetailDialog,
        FooterModular,
        HeaderMenuModular,
        PageTitleModular,
        MenuModular
    },
    data() {
        return {
            navIndex: [0, 0],
            title: '',
            cancel: '',
            menuVisible: true,
            version_active: false,

            detailDialogVisible: false,
            cur_nid: 0,
        }
    },
    created() {
        this.getUpInfo()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        getIndex(data) {
            if (data[0].length) {
                this.menuVisible = data[0] !== 5; //添加任务
                this.navIndex = data[0]
            }
            this.title = data[1]
            this.cancel = data[2]
            this.$nextTick(() => {
                this.$forceUpdate()
            })
        },
        async getUpInfo() {
            let _data = await getVersionDetail('')
            if (_data.status === 200) {
                this.cur_nid = _data.data.id
                this.detailDialogVisible = true
            }
        },

        watchState() {
            this.detailDialogVisible = false;
        },
        versionOut() {
            setTimeout(() => {
                this.version_active = false
            }, 300)
        }
    }

}
</script>

<style lang="scss" scoped>
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
    transition: all .2s ease;
}

.slide-fade-leave-active {
    transition: all .2s ease;
}

.slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */
{
    transform: translateX(-210px);
    opacity: 0.5;
}

.wrapper {
    width: 100%;
    min-height: 100vh;

    .main-container {
        width: calc(100% - 275px);
        min-width: 1610px;;

        &.max {
            width: calc(100%);
        }

        padding: 0 20px 20px 0;

        .content {
        }
    }
}

.version {
    position: fixed;
    bottom: 150px;
    right: -30px;
    width: 80px;
    transform: rotate(-60deg) scale(0.8);
    transition: all .2s ease;
}

.version.active {
    position: fixed;
    bottom: 150px;
    right: 20px;
    width: 80px;
    transform: rotate(0deg) scale(1);
}

</style>
